import * as RadixTooltip from "@radix-ui/react-tooltip";
import { Kbd } from "pages/flyer/builder/drawer/components/Primitives/Kbd";
import { styled } from "pages/flyer/builder/drawer/styles";
import * as React from "react";

/* -------------------------------------------------- */
/*                       Tooltip                      */
/* -------------------------------------------------- */

interface TooltipProps {
  children: React.ReactNode;
  label: string;
  kbd?: string;
  side?: "bottom" | "left" | "right" | "top";
}

export function Tooltip({ children, label, kbd: kbdProp, side = "top" }: TooltipProps): JSX.Element {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger dir="ltr" asChild={true}>
        <span>{children}</span>
      </RadixTooltip.Trigger>
      <StyledContent dir="ltr" side={side} sideOffset={8}>
        <Label>{label}</Label>
        {kbdProp ? <Kbd variant="tooltip">{kbdProp}</Kbd> : null}
        <StyledArrow />
      </StyledContent>
    </RadixTooltip.Root>
  );
}

const StyledContent = styled(RadixTooltip.Content, {
  borderRadius: 4,
  padding: "8px 16px",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  backgroundColor: "#0C172C",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: '"Inter", sans-serif',
  userSelect: "none",
  maxWidth: "300px",
  gap: "10px",
});

const StyledArrow = styled(RadixTooltip.Arrow, {
  fill: "#0C172C",
  margin: "0 8px",
});

const Label = styled("div", {
  whiteSpace: "pre-wrap",
});
